import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { JSONContent } from '@tiptap/core'
import { firstValueFrom } from 'rxjs'
import type { CitationMinuteNodes } from '../../../../../backend/src/citations/minutes-citations-api.dto'
import { MinutesVerboseness } from '../../calls.service'

export type RevisionSummary = {
  id: number
  createdAt: string
  authorName: string
  otherAuthorCount: number
  systemGenerated: boolean
  minutesVerboseness: MinutesVerboseness | null
  isCurrent: boolean
}

export type RevisionContent = {
  content: JSONContent
  citations: CitationMinuteNodes | null
}

@Injectable({ providedIn: 'root' })
export class EditorRevisionsService {
  private http = inject(HttpClient)

  listRevisions(callId: number): Promise<RevisionSummary[]> {
    return firstValueFrom(this.http.get<RevisionSummary[]>(`/api/tiptap-editor/calls/${callId}/revisions`))
  }

  getRevision(callId: number, revisionId: number): Promise<RevisionContent> {
    return firstValueFrom(this.http.get<RevisionContent>(`/api/tiptap-editor/calls/${callId}/revisions/${revisionId}`))
  }

  restoreRevision(callId: number, revisionId: number): Promise<RevisionContent> {
    return firstValueFrom(this.http.post<RevisionContent>(`/api/tiptap-editor/calls/${callId}/revisions/${revisionId}/restore`, {}))
  }
}
